// Search datalist - this is included twice in the menu, once for mobile, once for desktop

import FetchHelpers from "../fetch-helpers";
import {AsyncNotice} from "../notices/notice";

const searchLists = document.querySelectorAll("[name='f'][list]");
if(searchLists) {
  searchLists.forEach(async (element) => {
    preparePublicationsSearch(element)
  });
}

/**
 * Prepares the publications search by enabling functionality and adding event listeners.
 *
 * @param {HTMLElement} element - The input element for the publications search.
 */
function preparePublicationsSearch(element) {
  // Allows us to style up datalist, adapted from https://stackoverflow.com/a/68666235/13661618
  // Fixes the current focus skipping indices
  let currentFocus = -1;
  const instance = element.dataset.instance;
  const search_titles_datalist = document.getElementById('menu_search_titles_datalist' + instance);
  const search_titles_form = document.getElementById('menu_search_titles_form' + instance);
  const search_titles_input = document.querySelector('#menu_search_titles' + instance);
  const signInElem = document.querySelector('#stay-signed-in');
  let datalist_key = 'search_menu_titles_datalist';

  if(parseInt(search_titles_datalist.dataset.count) === 0) {
    if(sessionStorage.getItem(datalist_key)) {
      if(signInElem) {
        signInElem.removeAttribute('disabled');
      }
    }

    // if empty, load from async call to DB
    else {
      const url = search_titles_datalist.dataset.url;
      new FetchHelpers()
        .fetchData('POST', url, {instance})
        .then((result) => {
          if (result.success) {
            let {datalist} = result;
            sessionStorage.setItem(datalist_key, datalist);
          } else {
            const notice = new AsyncNotice('Could not load title search data list', 'error');
            notice
              .create({error: result.error})
              .then(() => {
                notice.remove();
              });
          }
        })
        .finally(() => {
          if(signInElem) {
            signInElem.removeAttribute('disabled');
          }
        });
    }

    // set titles datalist
    if (sessionStorage.getItem(datalist_key)) {
      search_titles_datalist.innerHTML = sessionStorage.getItem(datalist_key);
    }
  }

  if (search_titles_datalist?.children?.length ?? 0 !== 0) {
    search_titles_input.removeAttribute('disabled');
    for (let option of search_titles_datalist.children) {
      option.onclick = function () {
        window.location =
          window.location.protocol + "//" + window.location.host
          + "/books/reader.php?id="
          + option.dataset.id;
      }
    }

    element.oninput = function () {
      search_titles_datalist.style.display = 'block';
      currentFocus = -1;
      let {children} = search_titles_datalist;
      removeListActive(children);
      let {value} = element;
      let text = value.toUpperCase();
      text = text.replace('"', '');
      let words = text.split(" ");
      let count_words = 0;
      for (let option of search_titles_datalist.children) {
        if (words.every(function (word) { return option.title.toUpperCase().indexOf(word) > -1 })) {
          option.style.display = "block";
          count_words++;
        } else {
          option.style.display = "none";
        }
      }

      // Hide if no value at all
      if (text === '' || count_words < 1) {
        search_titles_datalist.style.display = 'none';
      } else {
        search_titles_datalist.style.display = 'block';
      }
    }

    element.onkeydown = function (e) {
      let {children: titles} = search_titles_datalist;
      if (e.key === 'ArrowDown') { // keyCode 40
        e.preventDefault();
        currentFocus++;
        while (currentFocus <= titles.length && titles[currentFocus].style.display === "none") {
          currentFocus++;
        }
        currentFocus = addListActive(titles, currentFocus);
      } else if (e.key === 'ArrowUp') { //  keyCode 38
        e.preventDefault();
        currentFocus--;
        while (currentFocus >= -1 && titles[currentFocus].style.display === "none") {
          currentFocus--;
        }
        currentFocus = addListActive(titles, currentFocus);
      } else if (e.key === 'Enter') { // keyCode 13
        // Enter key or click on an option: go straight to reader rather than titles A-Z
        e.preventDefault();
        if (currentFocus > -1) {
          // Simulate a click on the "active" item
          if (titles) {
            window.location =
              window.location.protocol + "//" + window.location.host
              + "/books/reader.php?id="
              + titles[currentFocus].dataset.id;
          }
        } else {
          search_titles_form.submit();
        }
      }
    }
  }

  // Advanced Search - use value from Search Ministry Contents input - also appears twice on page
  let menuAdvancedSearchButton = document.getElementById("menu_advanced_search_button" + instance);
  if(menuAdvancedSearchButton) {
    menuAdvancedSearchButton.addEventListener('click', function (e) {
      e.preventDefault();
      document.getElementById("menu_quick_search" + instance).value = "";
      document.getElementById("menu_search_content_form" + instance).submit();
    });
  }
}

/**
 * Adds the "active" class to a specified element in a list of elements
 * and scroll it into view
 *
 * @param  x - The list of DOM elements
 * @param {number} currentFocus - The index of the element to be made active
 * @return {number|boolean} - The index of the active element if successful,
 *                           false if the list is empty
 */
function addListActive(x, currentFocus) {
  if (!x) return false;
  removeListActive(x);
  if (currentFocus >= x.length) {
    currentFocus = 0;
  }
  if (currentFocus < 0) {
    currentFocus = (x.length - 1);
  }
  x[currentFocus].classList.add("active");
  x[currentFocus].scrollIntoView(false);
  return currentFocus;
}

/**
 * Remove the "active" class from the elements in the provided list.
 *
 * @param {HTMLCollection} x - The list of elements to remove the "active" class from.
 * @return {void} - This method does not return anything.
 */
function removeListActive(x) {
  for (let i = 0; i < x.length; i++) {
    x[i].classList.remove("active");
  }
}

